/* provide the hostname for production server */
const validTrackingHostName = 'kyburz-switzerland.ch';

window.addEventListener("DOMContentLoaded", function() {
    attachTrackingBlockingLink();
});

var trackingCookieName = 'kyburznotrack';

function attachTrackingBlockingLink() {
    var link = document.querySelector('#trackingBlockingLink');
    if (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            blockTracking();
        });
    }
}

/**
 * Set a "no track" cookie
 */
function blockTracking() {
    document.cookie = trackingCookieName + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
    window[trackingCookieName] = true;
    window.alert('Tracking was blocked for this browser.');
}

/**
 * Check if the user has a "no track" cookie
 * @returns {boolean}
 */
function isTrackingAllowed() {
    if (document.cookie.indexOf(trackingCookieName + '=true') > -1) {
        return false;
    }

    return true;
}

function isProductionServer() {
  if (window.location.hostname === validTrackingHostName) {
    return true;
  }
  return false;
}

/**
 * https://developers.google.com/analytics/devguides/collection/gtagjs/events
 * @param event
 */
var formGATrackingEvent = function(event)
{
    var form = event.target;

    // https://stackoverflow.com/questions/736513/how-do-i-parse-a-url-into-hostname-and-path-in-javascript
    var getLocation = function(href) {
        var l = document.createElement("a");
        l.href = href;
        return l;
    };

    var formName = form.name;
    var path = getLocation(form.baseURI).pathname;

    var gaInfo = {
        action: path,
        event_category: 'Form submission',
        event_label: formName,
    };

    window.gtag('event', gaInfo.action, {
        'event_category': gaInfo.event_category,
        'event_label': gaInfo.event_label
    });
};

/**
 * Attach Google Analytics Tracking Events to forms
 */
var initFormGATracking = function()
{
    var forms = $('.c-form form');

    if (forms.length === 0) {
        return;
    }

    forms.submit(formGATrackingEvent);
};

/**
 * functions to track the page view with Google, Facebook and Hotjar
 */
function track() {
    // Google gtag tracking
    loadScript("https://www.googletagmanager.com/gtag/js?id=UA-4431771-12", function() {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-4431771-12');
        window.gtag = gtag;

        initFormGATracking();
    });

    // Facebook tracking
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments);};if(!f._fbq)f._fbq=n; // jshint ignore:line
        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s);}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js'); // jshint ignore:line
    fbq('init', '110369159628716'); // Insert your pixel ID here.
    fbq('track', 'PageView');

    // Hotjar tracking
    (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments);};
        h._hjSettings={hjid:1335203,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
}

/**
 * Dynamically load a javascript source file from url and run the callback after script was loaded
 * @param url
 * @param callback
 */
function loadScript(url, callback) {
    // adding the script tag to the head as suggested before
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    // then bind the event to the callback function
    // there are several events for cross browser compatibility
    script.onreadystatechange = callback;
    script.onload = callback;

    // fire the loading
    head.appendChild(script);
}

if (
  isTrackingAllowed() &&
  isProductionServer()
) {
  track();
}
